export default __webpack_public_path__ + "3fc794a780c2c162758f7a4235d060a1.jpg";